export const FLIP_TRIGGERS = [
	{ label: 'Hover', value: 'hover' },
	{ label: 'Click', value: 'click' },
];

export const FLIP_DIRECTIONS = [
	{ label: 'Horizontal', value: 'horizontal' },
	{ label: 'Vertical', value: 'vertical' },
];

const OVERLAY_GROUP_ATTRS = {
	style: {
		border: {
			radius: {
				topLeft: '8px',
				topRight: '8px',
				bottomLeft: '8px',
				bottomRight: '8px',
			},
		},
		spacing: {
			padding: {
				top: '20px',
				right: '20px',
				bottom: '20px',
				left: '20px',
			},
		},
		elements: {
			link: {
				color: {
					text: 'var:preset|color|brandy-primary',
				},
			},
		},
	},
	backgroundColor: 'white',
	textColor: 'brandy-primary',
	layout: { type: 'constrained', justifyContent: 'center' },
};

export const TEMPLATE = [
	[
		'brandy/flip-card-front',
		{
			style: {
				border: {
					radius: '12px',
				},
			},
		},
		[
			[
				'core/cover',
				{
					url: 'https://images.wpbrandy.com/uploads/skateboards-post-img-1.webp',
					dimRatio: 30,
					contentPosition: 'bottom center',
					style: {
						spacing: {
							padding: {
								top: '20px',
								right: '20px',
								bottom: '20px',
								left: '20px',
							},
						},
					},
				},
				[
					[
						'core/group',
						OVERLAY_GROUP_ATTRS,
						[
							[
								'core/heading',
								{
									textAlign: 'center',
									level: 3,
									content: 'Flip Me',
								},
							],
							[
								'core/paragraph',
								{
									align: 'center',
									content:
										'Hover or click to discover more',
								},
							],
						],
					],
				],
			],
		],
	],
	[
		'brandy/flip-card-back',
		{
			style: {
				border: {
					radius: '12px',
				},
			},
		},
		[
			[
				'core/cover',
				{
					url: 'https://images.wpbrandy.com/uploads/skateboards-post-img-2.webp',
					dimRatio: 40,
					contentPosition: 'bottom center',
					style: {
						spacing: {
							padding: {
								top: '20px',
								right: '20px',
								bottom: '20px',
								left: '20px',
							},
						},
					},
				},
				[
					[
						'core/group',
						OVERLAY_GROUP_ATTRS,
						[
							[
								'core/heading',
								{
									textAlign: 'center',
									level: 3,
									content: 'Back Side',
								},
							],
							[
								'core/paragraph',
								{
									align: 'center',
									content:
										'Discover our latest collection',
								},
							],
							[
								'core/buttons',
								{
									layout: {
										type: 'flex',
										justifyContent: 'center',
									},
									style: {
										spacing: {
											margin: {
												top: '12px',
											},
										},
									},
								},
								[
									[
										'core/button',
										{
											text: 'Learn More',
											className:
												'is-style-outline',
										},
									],
								],
							],
						],
					],
				],
			],
		],
	],
];
